// extracted by mini-css-extract-plugin
export default {"successFooter":"ChangeCoverageOrcaSuccess_successFooter__DHjl1"};